<script lang="ts">
    import Row from '$components/Form/Row.svelte';
    import type { Form } from '@jmvdevelop/svelte-form';
    import type {
        Fields,
        MultiQuoteFormData,
    } from '$components/MultiQuoteForm/MultiQuoteFormData';
    import Select from '$components/Form/Select.svelte';
    import PrettyChoice from '$components/Form/PrettyChoice.svelte';
    import MeltMultiSelect from '$components/Form/MeltMultiSelect.svelte';
    import find from 'lodash/find';
    import Textarea from '$components/Form/Textarea.svelte';
    import Input from '$components/Form/Input.svelte';

    export let form: Form<MultiQuoteFormData, string>;
    export let fields: Fields<MultiQuoteFormData>;

    const serviceTypeOptions = [
        `Entretien courant (vidange, filtres…)`,
        `Réparation mécanique`,
        `Diagnostic électronique`,
        `Climatisation`,
        `Peinture / Carrosserie`,
        `Électricité auto`,
        `Préparation à la visite technique`,
        `Installation d'accessoires`,
        `Autre (à préciser ci-dessous)`,
    ].map((v) => ({ label: v, value: v }));

    const vehicleTypeOptions = [
        `Voiture citadine`,
        `4×4 / SUV`,
        `Voiture électrique`,
        `Véhicule utilitaire`,
        `Minibus / Bus`,
        `Camion`,
        `Autre (à préciser)`,
    ].map((v) => ({ label: v, value: v, key: v }));
</script>

<div class="flex flex-col gap-8 @container">
    <Row
        {form}
        field={fields.garageMecanique.serviceTypes}
        class=""
        let:field
        let:id
        label={`Quel type de service recherchez-vous ?`}
        helpLabel="max 3"
    >
        <MeltMultiSelect
            {form}
            {field}
            {id}
            placeholder=""
            options={serviceTypeOptions}
            valueToOption={(v) => ({
                value: v,
                label: find(serviceTypeOptions, (o) => o.value === v)?.label ?? '',
            })}
            max={3}
        />
    </Row>

    <Row
        {form}
        field={fields.garageMecanique.vehicleType}
        class=""
        let:field
        let:id
        label={`Pour quel type de véhicule ?`}
    >
        <PrettyChoice
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @2xl:grid-cols-2 gap-x-8"
            choices={vehicleTypeOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.garageMecanique.vehicleBrandModel}
        class=""
        let:field
        label={`Quelle est la marque et le modèle de votre véhicule ?`}
    >
        <Input {form} {field} toText={(id) => id} fromText={(id) => id} class={''} />
    </Row>

    <Row
        {form}
        field={fields.garageMecanique.vehicleYear}
        class=""
        let:field
        let:id
        label={`Année du véhicule`}
        helpLabel="(approximatif)"
    >
        <Select
            {form}
            {id}
            {field}
            required={false}
            showChevron
            options={Array.from({ length: 30 }, (_, i) => {
                const year = new Date().getFullYear() - i;
                return {
                    label: year.toString(),
                    value: year.toString(),
                    key: year.toString(),
                };
            })}
        />
    </Row>

    <Row
        {form}
        field={fields.message}
        required
        label={'Votre demande'}
        helpLabel="Précisez votre besoin, soyez le plus précis dans votre demande de devis"
        let:field
    >
        <Textarea
            {form}
            {field}
            placeholder={`Précisez votre besoin, soyez le plus précis dans votre demande de devis`}
            toText={(id) => id}
            fromText={(id) => id}
            class={''}
            rows={5}
        />
    </Row>
</div>
